export default "__VITE_ASSET__BKT3q3Ra__"